import React from "react";

import { useFormikContext } from "formik";
import { NoOfExternalLinkEnum } from "../../../../enums/template";
import { Template } from "../../../../models";

import RadioGroup, { Option } from "../../../../components/form/RadioGroup";
import SwitchContainer from "../common/SwitchContainer";

const noOfExtLinkOptions = [
  {
    id: NoOfExternalLinkEnum.ONE,
    name: "1 link",
  },
  {
    id: NoOfExternalLinkEnum.TWO,
    name: "2 links",
  },
];

export default function IncludeExternalLinkToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  return (
    <div className="space-y-2">
      <SwitchContainer
        title="Include External Link"
        tooltip="An external link is a hyperlink on a keyword that points to another website that is considered authoritative."
        enabled={values?.externalLinkCount !== NoOfExternalLinkEnum.ZERO}
        setEnabled={() => {
          if (values?.externalLinkCount !== NoOfExternalLinkEnum.ZERO) {
            setFieldValue("externalLinkCount", NoOfExternalLinkEnum.ZERO);
          } else {
            setFieldValue("externalLinkCount", NoOfExternalLinkEnum.ONE);
          }
        }}
      />
      {values?.externalLinkCount !== 0 && (
        <RadioGroup
          className="ml-14"
          options={noOfExtLinkOptions}
          name="externalLinkCount"
          selected={values?.externalLinkCount}
          onClick={({ id }: Option) => setFieldValue("externalLinkCount", id)}
        />
      )}
    </div>
  );
}
